import React, { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { fetchPublic } from "../adminApi";
import { Reveal, SplitWords } from "../motionHelpers";
import VideoModal from "../../components/VideoModal";

// Extract a YouTube video id from a full URL or raw id.
const ytId = (url) => {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
};

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchPublic("testimonials").then(setItems).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section id="testimonials" className="d2-bg py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="mb-14">
          <span className="font-grotesk uppercase tracking-[0.3em] text-sc-lime text-sm">Loved by players</span>
          <h2 className="font-display uppercase text-white text-5xl md:text-7xl leading-[0.9] mt-3">
            <SplitWords text="What Players Say" />
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => {
            const vid = ytId(t.video_url);
            return (
            <Reveal key={t.id || t.name} delay={i * 0.1}>
              <div className="d2-card bg-[#0b241a] border border-white/10 rounded-2xl p-8 h-full flex flex-col">
                {vid ? (
                  <div className="mb-6 -mx-2 -mt-2 rounded-xl overflow-hidden" data-testid={`testimonial-video-${i}`}>
                    <VideoModal videoId={vid} poster={`https://img.youtube.com/vi/${vid}/hqdefault.jpg`} label="Watch story" className="rounded-xl" />
                  </div>
                ) : (
                  <Quote className="w-9 h-9 text-sc-lime" />
                )}
                <div className="flex gap-1 mt-4">
                  {Array.from({ length: Math.max(0, Math.min(5, t.rating || 5)) }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 text-sc-lime fill-sc-lime" />
                  ))}
                </div>
                <p className="text-white/85 text-lg mt-4 font-grotesk leading-relaxed flex-1">“{t.quote}”</p>
                <div className="mt-6 flex items-center gap-3">
                  {t.photo ? (
                    <img src={t.photo} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                  ) : (
                    <span className="w-11 h-11 rounded-full bg-sc-lime/15 flex items-center justify-center font-display text-lg text-sc-lime">{(t.name || "?")[0]}</span>
                  )}
                  <div>
                    <p className="font-grotesk font-bold text-white leading-none">{t.name}</p>
                    <p className="font-mono2 text-[11px] uppercase tracking-widest text-white/40 mt-1">{t.role}</p>
                  </div>
                </div>
              </div>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
